<template>
  <div class="level">
    <div class="level-item">
      <div class="block has-text-centered">

        <!-- logo -->
        <img id="logo" class="image" src="@/assets/images/fend-logo.png">

        <!-- subtitle -->
        <div class="my-5">Securing smart infrastructure.</div>

        <form v-on:submit.prevent="submit" novalidate>
          <!-- email -->
          <div class="field">
            <div class="control">
              <input class="input" :class="{'is-danger': errors.password}"
                     type="email" placeholder="Email" v-model="email">
            </div>
          </div>

          <!-- password -->
          <div class="field">
            <div class="control">
              <input class="input" :class="{'is-danger': errors.password}"
                     type="password" placeholder="Password" v-model="password">
            </div>
          </div>

          <p v-show="errors.password" class="help is-danger pb-3">This email or password is invalid</p>

          <!-- submit -->
          <div class="control">
            <button class="button is-fullwidth is-primary">Sign in</button>
          </div>

          <!-- forgot password -->
          <div class="pt-4 is-size-6">
            <router-link class="has-text-primary" to="/forgot">Forgot password?</router-link>
          </div>
        </form>
        </div>
    </div>
  </div>
</template>

<script>
import api from '@/api';

export default {
  name: 'login',
  data() {
    return {
      email: '',
      password: '',
      errors: {}
    };
  },
  methods: {
    async submit() {
      try {
        const tokens = await api.auth.login(this.email, this.password);
        this.error = '';
        if (tokens) {
            this.$router.push('/mfa');
        } else {
          this.$router.push('/dashboard');
        }
      } catch (error) {
        this.errors = error.data || {};
      }
    },
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  #logo {
    max-width: 175px;
  }
  .level {
    flex-grow: 1;
    min-width:0; min-height:0;
  }
  .block {
    max-width: 400px;
  }
</style>
